import { objectToQueryString, splitArrayIntoChunks } from '@/common/js/utils';
import { stmHttpClient } from '@/plugins/HttpManager';
import { syncEventListToStorage, syncRequestArgsToStorage } from '@/service/secureMedia';
import { IGetEventListRes, TGetUserEventListArgs } from '@reolink-cloud/interface';
import { Async } from '@reolink-web/utils';

export const MAX_EVENT_COUNT = 300;

export const deleteEvents = async ( idArr: string[] ): Promise<void> => {

    for ( const chunk of splitArrayIntoChunks( idArr, MAX_EVENT_COUNT )) {

        await stmHttpClient.delete( `/cloud/event/items/${objectToQueryString({ id: chunk })}` );

    }

};

export function getEventList(
    args: TGetUserEventListArgs
): Promise<IGetEventListRes> {

    return new Promise(( resolve, reject ) => {

        const finalArgs = { ...args, v: 2 };
        Async.invokeAsync( async () => {

            await syncRequestArgsToStorage( finalArgs as Record<string, unknown> );

        });

        stmHttpClient.post<IGetEventListRes>( '/cloud/event/items/list-query/', finalArgs, { encryptRequestBody: false }).then( async res => {

            await syncEventListToStorage( res.data );
            resolve( res.data );

        }).catch( err => {

            reject( err );

        });

    });

}
